import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VertraegeComponent } from './components/vertraege/vertraege.component';
import { RouterModule, Routes } from '@angular/router';
import { RouteNames } from '../../route.name';
import { InsightSharedModule } from '../insight-shared/insight-shared.module';

const routes: Routes = [
    {path: RouteNames.BASE, component: VertraegeComponent},
    {path: RouteNames.SUB_PAGE, component: VertraegeComponent}
];

@NgModule({
    declarations: [
        VertraegeComponent
    ],
    imports: [
        CommonModule,
        InsightSharedModule,
        RouterModule.forChild(routes)
    ]
})
export class VertraegeModule {
}
